import { MenuList as MuiMenuList } from '@mui/material';
import type { MenuListProps as MuiMenuListProps } from '@mui/material';

export type MenuListProps = MuiMenuListProps;

/** List of MenuItems. Based on MUI MenuList: https://mui.com/material-ui/api/menu-list/ */
export const MenuList = (props: MenuListProps) => <MuiMenuList {...props} />;
